import React, { useState } from 'react'
import BINManagement from '../../BinManagement/AllBins'
import MCCConfiguration from './MccConfiguration'
import GeographyControl from './GeographyControl'
import CardLimits from './CardLimits'

function CardsConfiguration() {
    // Use consistent keys
    const tabs = [
        { title: "BIN Management", key: "bin-management" },
        { title: "MCC Configuration", key: "mcc-configuration" },
        { title: "Geography Control", key: "geography-control" },
        { title: "Card Limits", key: "card-limits" },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].key);

    const getTabContent = () => {
        switch (activeTab) {
            case "bin-management":
                return <BINManagement/>;
            case "mcc-configuration":
                return <MCCConfiguration />;
            case "geography-control":
                return <GeographyControl />;
            case "card-limits":
                return <CardLimits />;
            default:
                return null;
        }
    }

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    marginBottom: "1rem",
                    backgroundColor: "#f1f5f9",
                    borderRadius: "9999px",
                    padding: "4px",
                    maxWidth: "fit-content",
                }}
            >
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        style={{
                            padding: "8px 20px",
                            border: "none",
                            borderRadius: "9999px",
                            backgroundColor: activeTab === tab.key ? "#0f172a" : "transparent", // active tab dark
                            color: activeTab === tab.key ? "#fff" : "#64748b", // text color
                            fontWeight: activeTab === tab.key ? 600 : 500,
                            cursor: "pointer",
                            marginRight: "4px",
                        }}
                    >
                        {tab.title}
                    </button>
                ))}
            </div>
            {getTabContent()}
        </div>
    )
}

export default CardsConfiguration
